var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWench = function SvgWench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.845 4.154 19.5 7.5h-3v-3l3.345-3.346a6.5 6.5 0 0 0-8.634 8.806L1.086 20.086a2 2 0 0 0 2.828 2.828L14.04 12.788a6.5 6.5 0 0 0 8.805-8.634",
    className: "wench_svg__wench"
  })));
};
export default SvgWench;